import tenantTransformers from '@transformers';

const commonApiEndpoints = {
  getActiveProducts: {
    query: () => ({ url: `/api/products` }),
    transformer: (response) => tenantTransformers.productsDataMapper(response),
  },

  getMonthRules: {
    query: () => ({ url: `api/packages/custom_package_rules` }),
  },

  getPropertyAges: {
    query: () => ({ url: `/api/property_age` }),
    transformer: (response) => response?.property_ages || [],
  },

  getAdLicenseProducts: {
    query: () => ({ url: `/api/ad_license_products` }),
    transformer: (response) => response?.ad_license_products || [],
  },

  getListingTypesByParent: {
    query: (typeId) => ({ url: `/api/listing_types?q[parent_id_eq]=${typeId}` }),
    transformer: (response) => response?.listing_types || [],
  },

  createAdLicense: {
    query: (body) => {
      return {
      url: `/api/ad_license_requests`,
      method: 'POST',
      body: body,
    }},
  },
};

export default commonApiEndpoints;
